export const profileThemeColors = {
  default: { primary: "#f5f5f5", secondary: "#000000" },
  black: { primary: "#000000", secondary: "#ffffff" },
  blue: { primary: "#0047FF", secondary: "#ffffff" },
  purple: { primary: "#663192", secondary: "#ffffff" },
  yellow: { primary: "#FFCC00", secondary: "#ffffff" },
  red: { primary: "#FF543E", secondary: "#ffffff" },
  midnightBlue: { primary: "#233266", secondary: "#ffffff" },
  teal: { primary: "#84CDB8", secondary: "#ffffff" },
  gray: { primary: "#747474", secondary: "#ffffff" },
  pink: { primary: "#C837AB", secondary: "#ffffff" },
  green: { primary: "#00614B", secondary: "#ffffff" },
};
